import React, {useContext} from "react";
import css from "./css/BannerComponent.module.css";
import {Col, Container, Row} from "react-bootstrap";
import {SalvoContext} from "../contexts/SalvoContext";
import {useTranslation} from "react-i18next";

const BannerComponent = () => {
  const { trialInfo } = useContext(SalvoContext);
  const { t } = useTranslation();

  const getTrialExpiryWarning = () => {
    if (!trialInfo)
      return null;

    const expiry = new Date(trialInfo.expiryDate);
    const now = new Date();
    const diffDays = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) {
      return t("trial.expired");
    }

    if (diffDays <= 5) {
      return t("trial.expiresInDays", { days: diffDays });
    }

    return null;
  };

  const expiryWarning = getTrialExpiryWarning();

  if (!trialInfo || (!trialInfo.suspended && !expiryWarning)) {
    return null;
  }

  return (
    <div className={css.wrapper}>
      <Container>
        <Row>
          <Col className="d-flex justify-content-center align-items-center">
            <div className="text-center">
              {trialInfo.suspended && <div>🚫 {t("trial.suspended")}</div>}
              {!trialInfo.suspended && expiryWarning && (
                <div>⚠️ {expiryWarning}</div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BannerComponent;
